// Sort imports alphabetically
import { autoMatchBlueprint } from "./blueprint/auto-match-blueprint";
import { cancelScan } from "./use-cases/cancel-scan";
import { checkIfScanIsFinished } from "./use-cases/check-if-scan-is-finished";
import { disconnectServer } from "./use-cases/disconnect-server";
import { fetchMqttConfiguration } from "./use-cases/fetch-mqtt-configuration";
import { fetchSelectedBlueprint } from "./blueprint/fetch-selected-blueprint";
import { fetchServerLists } from "./use-cases/fetch-server-lists";
import { getInitialStructure } from "./use-cases/get-initial-structure";
import { getMyBlueprintLibrary } from "./blueprint/get-my-blueprint-library";
import { getNamespaceAndClientIds } from "./use-cases/get-namespace-and-client-ids";
import { getSavedStructureByClient } from "./use-cases/get-saved-structure-by-client";
import { getScanIsAlreadyQueued } from "./use-cases/get-scan-is-already-queued";
import { saveBlueprint } from "./blueprint/fetch-save-blueprint";
import { saveStructureFunction } from "./use-cases/save-structure";
import { getTileStructureByClient } from "./use-cases/get-tile-structure-by-client";
import { triggerScanAndGetServers } from "./use-cases/trigger-scan-and-get-servers";
import { updateBlueprint } from "./blueprint/update-blueprint";
import { updateClientConfiguration } from "./use-cases/update-client-configuration";
import { getGatewaysWithSources } from "./use-cases/get-gateways-with-sources";
import { putsUpdateSourceName } from "./use-cases/puts-update-source-name";
import { createDashboard } from "./use-cases/create-dashboard";
import { updateDashboard } from "./use-cases/update-dashboard";
import { getDashboards } from "./use-cases/get-dashboards";
import { putUpdateGatewayName } from "./use-cases/put-update-gateway-name";
import { getUsers } from "./user-manager/get-users";
import { getMachineGroups } from "./namespace-configuration/get-machine-groups";
import { getOrganizationById } from "./namespace-configuration/get-organization-by-id";
import { getOrganizations } from "./namespace-configuration/get-organizations";
import { getSourcesBySourceNamespace } from "./namespace-configuration/get-sources-by-source-namespace";
import { postCreateMachineGroup } from "./namespace-configuration/post-create-machine-group";
import { patchUpdateMachineGroup } from "./namespace-configuration/patch-update-machine-group";
import { postCreateRoutingPath } from "./namespace-configuration/post-create-routing-path";
import { putUpdateRoutingPath } from "./namespace-configuration/put-update-routing-path";
import { getServiceUsers } from "./user-manager/get-service-users";
import { postCreateUser } from "./user-manager/post-create-user";
import { putReactivateUser } from "./user-manager/put-reactivate-user";
import { putDeactivateUser } from "./user-manager/put-deactivate-user";
import { getGatewayServiceUsers } from "./user-manager/get-gateway-service-users";
import { patchUpdateUser } from "./user-manager/patch-update-user";
import { postCreateServiceUser } from "./user-manager/post-create-service-user";
import { patchUpdateServiceUser } from "./user-manager/patch-update-service-user";
import { postResendInvitationEmail } from "./user-manager/post-resend-invitation-email";
import { postRemove2FA } from "./user-manager/post-remove-2fa";
import { patchUserLanguage } from "./user-manager/patch-user-language";
import { getUserById } from "./user-manager/get-user-by-id";
import { getValidUserRoles } from "./user-manager/get-valid-user-roles";
import { postVPNDenySupportSession } from "./vpn-manager/vpn-post-deny-support-session";
import { getVPNSupportSessions } from "./vpn-manager/vpn-get-support-sessions";
import { getVPNSupportSessionsById } from "./vpn-manager/vpn-get-support-sessions-by-id";
import { postVPNRequestSupportSession } from "./vpn-manager/vpn-post-request-support-session";
import { postVPNAcceptSupportSession } from "./vpn-manager/vpn-post-accept-support-session";
import { postVPNCancelSupportSession } from "./vpn-manager/vpn-post-cancel-support-session";
import { postVPNInterruptSupportSession } from "./vpn-manager/vpn-post-interrupt-support-session";
import { postVPNAuthKeySupportSession } from "./vpn-manager/vpn-post-generate-auth-key-support-session";
import { getAllGatewaysWithSources } from "./vpn-manager/vpn-get-all-gateways-with-sources";
import { getRolesDescriptions } from "./role-manager/get-roles-descriptions";
import { getFirmwares } from "./ota-update/get-firmwares";
import { getBackups } from "./ota-update/get-backups";
import { getConfigurations } from "./ota-update/get-configurations";
import { getCurrentFirmwareVersion } from "./ota-update/get-firmware-current-version";
import { getConfigurationBackups } from "./ota-update/get-configuration-backups";
import { getAlarmsAndNotifications } from "./support/get-alarms-notifications";
import { getSupportCommentsByTicket } from "./support/get-support-comments-by-ticket";
import { patchTicketAutoTranslation } from "./support/patch-ticket-auto-translation";
import { patchTicketSourceId } from "./support/patch-ticket-source-id";
import { postRequestTechnicalSupport } from "./support/post-request-technical-support";
import { postSupportCommentByTicket } from "./support/post-support-comment-by-ticket";
import { postUploadAttachment } from "./support/post-upload-attachment";
import { patchTicketPriority } from "./support/patch-ticket-priority";
import { patchTicketStatus } from "./support/patch-ticket-status";
import { patchTicketAssignee } from "./support/patch-ticket-assignee";
import { getSupportAgents } from "./user-manager/get-support-agents";
import { getUsersByRole } from "./user-manager/get-users-by-role";
import { downloadConfiguration } from "./ota-update/download-configuration";
import { downloadConfigurationBackup } from "./ota-update/download-configuration-backup";
import { downloadFirmware } from "./ota-update/download-firmware";
import { downloadFirmwareBackup } from "./ota-update/download-firmware-backup";
import { isFilenameUsable } from "./ota-update/is-filename-usable";
import { postFirmwareUpload } from "./ota-update/post-upload-firmware";
import { postConfigurationUpload } from "./ota-update/post-upload-configuration";
import { postInstallFirmware } from "./ota-update/post-install-firmware";
import { getInstallFirmwareStatus } from "./ota-update/get-firmware-install-status";
import { postCreateFirmwareBackup } from "./ota-update/post-firmware-backup";
import { postCreateConfigurationBackup } from "./ota-update/post-configuration-backup";
import { postInstallConfiguration } from "./ota-update/post-install-configuration";
import { getInstallConfigurationStatus } from "./ota-update/get-configuration-install-status";
import { getInstallFirmwareBackupStatus } from "./ota-update/get-firmware-backup-install-status";
import { getInstallConfigurationBackupStatus } from "./ota-update/get-configuration-backup-install-status";
import { postInstallFirmwareBackup } from "./ota-update/post-install-firmware-backup";
import { postInstallConfigurationBackup } from "./ota-update/post-install-configuration-backup";
import { deleteFirmware } from "./ota-update/delete-firmware";
import { deleteConfiguration } from "./ota-update/delete-configuration";
import { deleteConfigurationBackup } from "./ota-update/delete-configuration-backup";
import { deleteFirmwareBackup } from "./ota-update/delete-firmware-backup";
import { getAllSourcesList } from "./client-configuration/get-all-sources-list";
import { cleanupGateway } from "./client-configuration/cleanup-gateway";
import { getGatewayById } from "./client-configuration/get-gateway-by-id";
import { getGatewayOperationStatus } from "./client-configuration/get-gateway-operation-status";
import { getSourceById } from "./client-configuration/get-source-by-id";
import { postGatewayIsAnnounced } from "./client-configuration/post-gateway-is-announced";
import { postGatewayOnboard } from "./client-configuration/post-gateway-onboard";
import { getSupportTicketById } from "./support/get-support-ticket-by-id";
import { getSupportTickets } from "./support/get-support-tickets";
import { getSupportCommentsByTicketWithLanguage } from "./support/get-support-comments-by-ticket-with-language";
import { getSupportTicketByIdWithLanguage } from "./support/get-support-ticket-by-id-with-language";
import { getSupportTicketsWithLanguage } from "./support/get-support-tickets-with-language";
import { getAbortInstall } from "./ota-update/get-abort-install";
import { getSupportTicketsWithStatusWithLanguage } from "./support/get-support-tickets-with-status-with-language";
import { getMySupportTicketsWithLanguage } from "./support/get-my-support-tickets-with-language";
import { putAlarmProfilesAPI } from "./alarms/put-transfer-alarm-profiles.to-client-api";
import { getAlarmProfilesAPI } from "./alarms/get-alarm-profile-api";
import { getQueryTimeseriesForNodeAPI } from "./timeseries/get-query-timeseries-for-node-api";
import { getEventsForSourceAPI } from "./events/get-events-for-source-api";
import { getQueryLastTimeseriesByMetadataAPI } from "./timeseries/get-query-last-timeseires-by-metadata-api";
import { getClientById } from "./client-configuration/get-client-by-id";
import { createSupportTicketWithAI } from "./support/create-support-ticket-with-ai";
import { createInstallationProcess } from "./ota-update/create-installation-process";
import { createProcessApi } from "./ota-update/create-process-api";
import { cancelInstallationProcess } from "./ota-update/cancel-installation-process";
import { approveInstallationProcess } from "./ota-update/approve-installation-process";
import { denyInstallationProcess } from "./ota-update/deny-installation-process";
import { startInstallationProcess } from "./ota-update/start-installation-process";
import { activeInstallationProcess } from "./ota-update/active-installation-process";
import { getInstallationProcess } from "./ota-update/get-installation-process";
import { getInstallationProcessList } from "./ota-update/get-installation-process-list";
import { postCheckMachineAvailability } from "./client-configuration/post-check-machine-availability";
import { postCreateSkill } from "./client-configuration/post-create-skill";
import { postGenerateOpcUaClientCertificate } from "./client-configuration/post-generate-opcua-client-certificate";
import { getDashboardsV2 } from "./dashboards-v2/get-dashboards-v2";
import { getWidgetTemplatesV2 } from "./dashboards-v2/get-widget-templates-v2";
import { getDashboardByIdV2 } from "./dashboards-v2/get-dashboard-by-id-v2";
import { postCreateDashboardV2 } from "./dashboards-v2/post-create-dashboard-v2";
import { patchDashboardV2 } from "./dashboards-v2/patch-dashboard-v2";
import { deleteDashboardV2 } from "./dashboards-v2/delete-dashboard-v2";
import { postDuplicateDashboardV2 } from "./dashboards-v2/post-duplicate-dashboard-v2";
import { postAddWidgetFromTemplateV2 } from "./dashboards-v2/post-add-widget-from-template-v2";
import { putUpdateWidgetV2 } from "./dashboards-v2/put-update-widget-v2";
import { patchPositioningV2 } from "./dashboards-v2/patch-positioning-v2";
import { deleteWidgetV2 } from "./dashboards-v2/delete-widget-v2";
import { postDuplicateWidgetV2 } from "./dashboards-v2/post-duplicate-widget-v2";
import { getActiveTimeseries } from "./timeseries/get-active-timeseries";
import { getUnits } from "./timeseries/get-units";
import { getImmMeasurement } from "./measurements/get-query-imm-measurement";

// Sort entries alphabetically
const apiUseCases = {
  autoMatchBlueprint,
  cancelScan,
  checkIfScanIsFinished,
  createDashboard,
  createInstallationProcess,
  createProcessApi,
  disconnectServer,
  fetchMqttConfiguration,
  fetchSelectedBlueprint,
  fetchServerLists,
  getAllSourcesList,
  cleanupGateway,
  getAllGatewaysWithSources,
  getGatewayById,
  getGatewayOperationStatus,
  getBackups,
  getConfigurationBackups,
  getConfigurations,
  getCurrentFirmwareVersion,
  getDashboards,
  getFirmwares,
  getGatewayServiceUsers,
  getGatewaysWithSources,
  getInitialStructure,
  getMachineGroups,
  getOrganizationById,
  getMyBlueprintLibrary,
  getNamespaceAndClientIds,
  getOrganizations,
  getSourcesBySourceNamespace,
  getAlarmsAndNotifications,
  getRolesDescriptions,
  getSavedStructureByClient,
  getScanIsAlreadyQueued,
  getServiceUsers,
  getSupportAgents,
  getSupportTicketById,
  getSupportTickets,
  getTileStructureByClient,
  getUserById,
  getUsers,
  getUsersByRole,
  getValidUserRoles,
  getVPNSupportSessions,
  getVPNSupportSessionsById,
  patchTicketAssignee,
  patchTicketAutoTranslation,
  patchTicketSourceId,
  patchUpdateMachineGroup,
  patchTicketPriority,
  patchTicketStatus,
  patchUpdateServiceUser,
  patchUpdateUser,
  patchUserLanguage,
  postRequestTechnicalSupport,
  postVPNRequestSupportSession,
  postVPNCancelSupportSession,
  postVPNInterruptSupportSession,
  postCreateUser,
  postCreateServiceUser,
  postCreateMachineGroup,
  postCreateRoutingPath,
  putUpdateRoutingPath,
  postRemove2FA,
  postResendInvitationEmail,
  postVPNAcceptSupportSession,
  postVPNAuthKeySupportSession,
  postVPNDenySupportSession,
  postCheckMachineAvailability,
  putDeactivateUser,
  putReactivateUser,
  putsUpdateSourceName,
  putUpdateGatewayName,
  saveBlueprint,
  saveStructureFunction,
  triggerScanAndGetServers,
  updateBlueprint,
  updateClientConfiguration,
  getSupportCommentsByTicket,
  postSupportCommentByTicket,
  postUploadAttachment,
  updateDashboard,
  downloadConfiguration,
  downloadConfigurationBackup,
  downloadFirmware,
  downloadFirmwareBackup,
  isFilenameUsable,
  postFirmwareUpload,
  postConfigurationUpload,
  postInstallFirmware,
  getInstallFirmwareStatus,
  postCreateFirmwareBackup,
  postCreateConfigurationBackup,
  postInstallConfiguration,
  getInstallConfigurationStatus,
  getInstallFirmwareBackupStatus,
  getInstallConfigurationBackupStatus,
  postInstallFirmwareBackup,
  postInstallConfigurationBackup,
  postGatewayIsAnnounced,
  postGatewayOnboard,
  deleteFirmware,
  deleteConfiguration,
  deleteConfigurationBackup,
  deleteFirmwareBackup,
  getSourceById,
  getSupportCommentsByTicketWithLanguage,
  getSupportTicketByIdWithLanguage,
  getSupportTicketsWithLanguage,
  getAbortInstall,
  getSupportTicketsWithStatusWithLanguage,
  getMySupportTicketsWithLanguage,
  getAlarmProfilesAPI,
  putAlarmProfilesAPI,
  getQueryTimeseriesForNodeAPI,
  getEventsForSourceAPI,
  getQueryLastTimeseriesByMetadataAPI,
  getClientById,
  createSupportTicketWithAI,
  approveInstallationProcess,
  cancelInstallationProcess,
  denyInstallationProcess,
  startInstallationProcess,
  activeInstallationProcess,
  getInstallationProcess,
  getInstallationProcessList,
  postCreateSkill,
  postGenerateOpcUaClientCertificate,
  getDashboardsV2,
  getWidgetTemplatesV2,
  postAddWidgetFromTemplateV2,
  putUpdateWidgetV2,
  patchPositioningV2,
  deleteWidgetV2,
  postDuplicateWidgetV2,
  getDashboardByIdV2,
  postCreateDashboardV2,
  patchDashboardV2,
  deleteDashboardV2,
  postDuplicateDashboardV2,
  getActiveTimeseries,
  getUnits,
  getImmMeasurement,
};

export default apiUseCases;
